import { db, storage } from "@/firebase";
import moment from "moment";

export const handleGetDevice = async (payload, callback) => {
  try {
    await db
      .ref("devices")
      .child(payload)
      .once("value", function(snapshot) {
        callback(snapshot.val());
      });
  } catch {
    console.log("Error");
  }
};

export const handleGetAllDevices = async (callback) => {
  try {
    await db.ref("devices").on("value", function(snapshot) {
      const devices = new Array();

      snapshot.forEach((res) => {
        const element = res.val();

        const device = {
          id: res.key,
          ...(element.firmware
            ? { firmware: element.firmware }
            : { firmware: null }),
          ...(element.setDeviceName
            ? { deviceName: element.setDeviceName }
            : { deviceName: res.key }),
          ...(element.BatVoltagePercent
            ? { batteryPercent: element.BatVoltagePercent }
            : { batteryPercent: "Unknown" }),
          ...(element.LastUpdateUnix
            ? { lastUpdate: element.LastUpdateUnix }
            : { lastUpdate: null }),
          ...(element.WiFiRSSIpercent
            ? { wifiSignal: element.WiFiRSSIpercent }
            : { wifiSignal: "Unknown" }),
          ...element,
        };

        devices.push(device);
      });
      callback(devices);
    });
  } catch (err) {
    console.error(err);
  }
};

export const handleUpdateDevice = async (payload) => {
  try {
    db.ref("devices")
      .child(payload.id)
      .update({
        setDeviceName: payload.setDeviceName,
        setSleepSeconds: payload.setSleepSeconds,
        resetMinMax: payload.resetMinMax,
      });
  } catch (err) {
    console.log(err);
  }
};

export const handleUploadFirmware = async (payload) => {
  try {
    const ref = storage.ref("Firmwares").child(payload.id);

    await ref
      .listAll()
      .then((dir) => {
        dir.items.forEach((fileRef) => {
          ref.child(fileRef.name).delete();
        });
      })
      .then(() => {
        return ref
          .child(payload.name)
          .put(payload.file)
          .then((uploadTaskSnapshot) => {
            return uploadTaskSnapshot.ref.getDownloadURL();
          })
          .then((fileUrl) => {
            return db
              .ref("devices")
              .child(payload.id)
              .child("firmware")
              .update({
                url: fileUrl,
                update: 1,
                uploadDate: moment(new Date()).format("hh:mmA, DD/MM/YY"),
                fileName: payload.name,
              });
          })
          .catch((error) => {
            console.error("Error uploading file: ", error);
          });
      });
  } catch (err) {
    console.log(err);
  }
};

export const handleDeleteFirmware = async (payload) => {
  try {
    const ref = storage.ref("Firmwares").child(payload.id);

    await ref
      .child(payload.name)
      .delete()
      .then(() => {
        return db
          .ref("devices")
          .child(payload.id)
          .remove();
      })
      .then(() => {
        return db
          .ref("chartData")
          .child(payload.id)
          .remove();
      });
  } catch (err) {
    console.log(err);
  }
};
